import { Component, Input, ChangeDetectorRef, ChangeDetectionStrategy, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * CATIA tarzı seçim listesi — bir feature'ın seçili yüz/kenar öğelerini satır satır gösterir.
 * Her satır: merkez-koord etiketi + ✕ kaldır. Üstte "temizle", altta "3D'den ekle".
 * Satıra gelince 3D sahnede o öğenin merkezinde parlak işaret belirir (hover vurgu).
 */
@Component({
  selector: 'fikoyt-secim-listesi',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  template: `
  <div class="sl" *ngIf="element && yonetici">
    <div class="sl-bas">
      <span>{{ tip === 'yuz' ? '🟧 Seçili Yüzler' : '🟩 Seçili Kenarlar' }} ({{ liste().length }})</span>
      @if(liste().length){ <button class="sl-temizle" (click)="temizle()" title="Tümünü kaldır">temizle</button> }
    </div>
    @if(liste().length){
      <div class="sl-liste">
        @for(o of liste(); track o.idx){
          <div class="sl-satir" (mouseenter)="vurgu(o.idx)" (mouseleave)="vurguBitir()">
            <span class="sl-et">{{ o.etiket }}</span>
            <button class="sl-sil" (click)="sil(o.idx)" title="Kaldır">✕</button>
          </div>
        }
      </div>
    } @else {
      <div class="sl-bos">Henüz seçim yok — aşağıdan 3D'den ekle.</div>
    }
    <button class="sl-ekle" [class.aktif]="aktif" (click)="ekle()">🎯 {{ tip === 'yuz' ? 'Yüz' : 'Kenar' }} Ekle / Değiştir (3D)</button>
  </div>`,
  styles: [`
    .sl{margin:2px 0 4px;}
    .sl-bas{display:flex;align-items:center;justify-content:space-between;font-size:10px;font-weight:800;color:#7db0ff;text-transform:uppercase;letter-spacing:.4px;margin:0 0 4px;}
    .sl-temizle{background:none;border:none;color:#fca5a5;font-size:10px;cursor:pointer;text-decoration:underline;padding:0;}
    .sl-temizle:hover{color:#f87171;}
    .sl-liste{max-height:130px;overflow-y:auto;display:flex;flex-direction:column;gap:2px;margin-bottom:5px;}
    .sl-satir{display:flex;align-items:center;justify-content:space-between;gap:6px;background:rgba(10,25,40,.6);border:1px solid rgba(0,180,255,.2);border-radius:5px;padding:3px 4px 3px 7px;cursor:default;transition:all .12s;}
    .sl-satir:hover{background:rgba(56,189,248,.22);border-color:rgba(56,189,248,.6);}
    .sl-et{font-size:10.5px;color:#cfe6f5;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
    .sl-sil{flex:0 0 18px;background:rgba(120,30,30,.5);border:1px solid rgba(239,68,68,.4);border-radius:4px;color:#fca5a5;cursor:pointer;font-size:10px;line-height:1;padding:1px 0;}
    .sl-sil:hover{background:rgba(180,40,40,.8);color:#fff;}
    .sl-bos{font-size:10.5px;color:#8593a8;font-style:italic;padding:3px 0 6px;}
    .sl-ekle{width:100%;background:rgba(56,189,248,.15);border:1px solid rgba(56,189,248,.4);border-radius:6px;color:#cfe6f5;cursor:pointer;padding:5px 8px;font-size:11px;font-weight:600;transition:all .15s;}
    .sl-ekle:hover{background:rgba(56,189,248,.32);}
    .sl-ekle.aktif{background:rgba(250,204,21,.25);border-color:rgba(250,204,21,.7);animation:slNabiz 1s infinite;}
    @keyframes slNabiz{0%,100%{box-shadow:0 0 0 0 rgba(250,204,21,.4);}50%{box-shadow:0 0 0 4px rgba(250,204,21,0);}}
  `]
})
export class FikoSecimListesi implements OnInit, OnDestroy {
  @Input() element: any;
  @Input() yonetici: any;
  @Input() tip: 'yuz' | 'kenar' = 'yuz';
  constructor(public CD: ChangeDetectorRef) {}

  private _dinle = () => this.CD.markForCheck();   // 3D'de yüz/kenar seçilince liste anında tazelensin
  ngOnInit(): void { this.yonetici?.secimDegisimDinle?.(this._dinle); }
  ngOnDestroy(): void { this.yonetici?.secimDegisimBirak?.(this._dinle); }

  liste(): { idx: number; etiket: string }[] { return this.yonetici?.secimListesi?.(this.element, this.tip) || []; }
  get aktif(): boolean { return this.tip === 'yuz' ? !!this.yonetici?.yuzSecimAktif : !!this.yonetici?.kenarSecimAktif; }
  sil(i: number): void { this.yonetici?.secimListeSil(this.element, this.tip, i); this.CD.markForCheck(); }
  temizle(): void { this.yonetici?.secimListeTemizle(this.element, this.tip); this.CD.markForCheck(); }
  ekle(): void { this.yonetici?.secimListeEkle(this.element, this.tip); this.CD.markForCheck(); }
  vurgu(i: number): void { this.yonetici?.secimListeVurgula(this.element, this.tip, i); }
  vurguBitir(): void { this.yonetici?.secimListeVurguBitir(); }
}
